<template>
  <el-popover ref="popover" placement="bottom-end" :visible-arrow='false' trigger="manual" v-model="visiable" popper-class='tages-popopver' @after-leave="afterLeave">
    <div class="mulity-menu-wrap" @click="handleVisible" :style="{width:latestClickedCity ? '640px' : '420px','margin-left': latestClickedCity?'-640px' : '-420px'}" v-show="!isSearch">
      <div class="search-select-options">
        <!-- v-if="visiable" -->
        <div class="options-wrapper">
          <div class="menu-tab provice">
            <div class="hierarchy-name">省</div>
            <el-scrollbar ref='clickselect' wrap-class="clickselect-scroll_wrap">
              <div class="menu-list" ref="industryList">
                <div @click="clickProvice(province)" v-for="(province, index) in locationOptions.normal" :key="index" class="menu-item"
                  :class="{'selectedArea': isSelectedCity(province,true)|| province.isChecked ,'currentSelect':province.NUM==provinceNum}">
                  <div :ref="'pro' + province.NUM" :id="'province' + province.NUM">
                    {{province.NAME}}
                    <span v-if="isSelectedCity(province,true)">（{{ isSelectedCity(province,true) }}）</span>
                  </div>
                </div>
              </div>
            </el-scrollbar>
          </div>
          <div class="menu-tab city">
            <div class="hierarchy-name">市</div>
            <el-scrollbar ref='clickselect' wrap-class="clickselect-scroll_wrap">
              <div class="menu-list area-list">
                <div class="menu-item" :class="{'selected': selectedProvice.isChecked}" @click="clickNode(selectedProvice)">全部</div>
                <!-- 'currentSelect': isSelectedCity(city) && !selectedProvice.isChecked, -->
                <div class="menu-item" :class="{'currentSelect': latestClickedCity && latestClickedCity.NUM === city.NUM,'selected':computeChildrenCount(city) > 0 || isSelectedCity(city)}"
                  @click="clickCity(city)" v-for="(city, index) in selectedProvice.children" :key="index">
                  <div>
                    {{city.NAME}}<span v-if="computeChildrenCount(city) > 0">（{{ computeChildrenCount(city) }}）</span>
                  </div>
                </div>
              </div>
            </el-scrollbar>
          </div>
          <div class="menu-tab district" v-if="displayDistrict(selectedProvice)">
            <div class="hierarchy-name">区</div>
            <el-scrollbar ref='clickselect' wrap-class="clickselect-scroll_wrap">
              <div class="menu-list area-list">
                <span class="menu-item" @click="clickNode(latestClickedCity,true)" :class="{'selected': latestClickedCity.isChecked}">全部</span>
                <div class="menu-item" :class="[ {'selected': district.isChecked}]" @click="clickNode(district,true)" v-for="(district, index) in latestClickedCity.children" :key="index">
                  <span> {{district.NAME}} </span>
                </div>
              </div>
            </el-scrollbar>
          </div>
        </div>
      </div>
    </div>
    <div class="mulity-menu-wrap mulity-menu-search" v-show="isSearch" @click="handleVisible">
      <div class="menu-tab flex-box">
        <el-scrollbar ref='clickselect' wrap-class="clickselect-scroll_wrap">
          <div class="suggestion-text">
            搜索结果：
          </div>
          <div class="menu-list">
            <div class="no-data" v-if="searchIndustry.length == 0">
              <span>未找到匹配的结果</span>
            </div>
            <div class="menu-item" :class="{
                  'selected': selectedCode.indexOf(item.code)!=-1,
                }" v-else v-for="(item) in searchIndustry" :key="item.code" @click="doSelect(item)">
              <div class="menu-item-name" v-html="item.showText"></div>
            </div>
          </div>
        </el-scrollbar>
      </div>
    </div>

    <!-- 输入框/标签 -->
    <div :class='["search-select-wrap",error.length>0 ? "error-border" :""]' slot="reference">
      <div class="select-tag" :class="{'emptyError':error }">
        <template v-for="item in selectedList">
          <span :key="item.code" class="tag-item" :class="{'activated': item.isActivated}">
            {{ displayTag(item) }}
            <span class="clear-icon el-icon-close" @click.stop="setChecked(item,false)"></span>
          </span>
        </template>
        <!-- <div @click.stop="clearAll" class="select-drown-icon el-icon-error" v-if="isFocus &&selectedList.length>0"></div> 
      <div class="select-drown-icon el-icon-caret-bottom" v-if="!isFocus ||selectedList.length <=0"></div> -->
      </div>
      <input type="text" ref="menuInputFocus" class="tag-search" :class="{'focus': isFocus}" v-model.lazy="searchKeyWord" :placeholder="searchKeyWord || selectedList.length>0 ? '' : placeholder"
        @input="searchQueryString" @keyup.backspace="removeKeyEnter" @focus="handleFocus" @blur="onBlur" @compositionstart="hasValue=false" @compositionend="hasValue=true" />
    </div>
  </el-popover>
</template>

<script>
// import areaOption from '../../common/areaOption'
import Clickoutside from '@/utils/clickoutside';
// import { administrativeAreas } from '../../../common/administrativeAreas';
import isEmpty from 'lodash/isEmpty';
export default {
  props: ['selected', 'placeholder', 'industryOption', 'options', 'error'],
  // props: {
  //   selected: {
  //     type: Array,
  //     default: []
  //   }
  // },
  directives: { Clickoutside },
  data() {
    return {
      //   locationOptions: this.cloneDeep(administrativeAreas),
      locationOptions: [],
      keyword: '',
      codeMap: ['A', 'B', 'C', 'F', 'G', 'H', 'J', 'L', 'N', 'Q', 'S', 'T', 'X', 'Y', 'Z'],
      latestClickedCity: null,
      selectedProvice: {},
      searchKeyWord: '',
      visiable: false,//
      selectedCode: [],
      isFocus: false,
      // searchQueryString:'',
      deleteCount: 0,
      isEmpty: true, //判断省市区是否都为空
      provinceNum: '34', //省份点击高亮
      timer: null, // 输入文本定时器
      isSearch: false,
      hasValue: true,
      searchIndustry: [], // 搜索结果
    };
  },

  created() {
    this.selectedProvice = this.locationOptions.normal[0];
    const hotNumList = this.locationOptions.hot.map(item => item.NUM)
    let hotNodeList = []
    let selected;
    if (!this.selected) {
      selected = []
    } else {
      selected = [...this.selected.province, ...this.selected.city, ...this.selected.district]
    }
    this._cascadeDown({ children: this.locationOptions.normal }, node => {
      // 选中节点
      iteratorNode(node, selected, () => this.setChecked(node, true))
      // 从normal中搜集热门城市
      // iteratorNode(node, hotNumList, () => hotNodeList.push(node))
    })
    // this.locationOptions.hotNodeList = hotNodeList

    function iteratorNode(node, nodeList = [], cb) {
      let checkedIdx = nodeList.findIndex(num => num === node.NUM)
      if (checkedIdx !== -1) {
        cb()
      }
    }
  },

  //  watch: {
  //    selectedList: {
  //      handler (val) {
  //         console.log('---->', val.map(item => item.NUM))
  //      },
  //      deep: true
  //    }
  //  },

  watch: {
    selected(val) {
      if (val) {
        this.selectedCode = [...val.province, ...val.city, ...val.district]
      } else {
        this.selectedCode = []
      }
    },
    // selectedList(){

    // }
    searchKeyWord(value) {
      if (!value)
        this.deleteCount = 0;
    },
  },

  computed: {
    selectedList() {
      let result = []
      this._cascadeDown({ children: this.locationOptions.normal }, node => {
        node.isChecked && result.push(node)
      })
      // result.forEach((item)=>{
      //   this.selectedCode.push(item.NUM)
      // })
      return result
    }
  },
  mounted() { },
  methods: {
    validator() {
      return this.isEmpty ? '请填选必填项' : ''
    },
    handleVisible() {
      this.$refs.menuInputFocus.focus();
    },
    initArea() {
      let selected = this.selectedList.map(item => item.NUM);
      let province = []
      let city = []
      let district = []
      for (let index = 0; index < selected.length; index++) {
        let currentVal = selected[index]
        let directCities = ['1101', '3101', '5001', '1201']

        if (currentVal.length == '2') {
          province.push(currentVal)
        } else if (currentVal.length == '4') {
          if (directCities.indexOf(currentVal) != -1) {
            province.push(currentVal)
          } else {
            city.push(currentVal)
          }
        } else {
          district.push(currentVal)
        }
      }
      if (selected.length <= 0) {
        this.isEmpty = true;
      } else {
        this.isEmpty = false;
      }
      // this.isEmpty=!isEmpty(province) ||!isEmpty(city) ||!isEmpty(district);
      this.$emit('changeArea', { province: province, city: city, district: district })
    },
    clickFocus() {
      this.$refs.menuInputFocus.focus();
    },
    stopBubble($event) {
      $event.stopPropagation();
    },
    handleFocus() {
      this.isFocus = true;
      this.visiable = true;
      // if(!this.searchKeyWord){
      //   this.visiable = true;
      // }
      clearTimeout(this.timer)
      this.$emit('input-cv-focus', true);
    },
    /** 
    * 失焦收起
    */
    onBlur() {
      this.timer = setTimeout(() => {
        this.visiable = false;
        this.isFocus = false;
        this.searchKeyWord = '';
        this.$emit('input-cv-focus', false);
      }, 300)
    },
    close() {
      this.isFocus = false;
      this.visiable = false;
    },
    // 点击字母导航，滚动到指定位置
    scrollToLocation(letter) {
      this._scrollTo(`#letter${letter}`)
    },

    checkChina() {
      this._cascadeDown({ children: this.locationOptions.normal }, node => this.setChecked(node, false))
    },

    //点击市（非叶子节点，只会做toggle区域模块，不做实际选中）
    clickCity(city) {
      this.latestClickedCity = this.latestClickedCity === city ? null : city
      this.$refs.menuInputFocus.focus();
    },
    clickProvice(item) {
      this.selectedProvice = item;
      this.provinceNum = item.NUM;
      this.$refs.menuInputFocus.focus();
    },

    isSelectedCity(node, isProvice) {
      let result = 0
      if (isProvice) {
        node.children.map((item) => {
          if (this.computeChildrenCount(item) != 0 || item.isChecked) {
            result++;
          }
        })
        return result
      } else {
        const isSelectChild = node.isChecked || node.children.some(item => item.isChecked)
        const isSelectCurrentCity = this.latestClickedCity && this.latestClickedCity.NUM === node.NUM
        return isSelectChild
        //  || isSelectCurrentCity
      }
    },
    //控制区域显示
    displayDistrict(province) {
      return this.latestClickedCity &&
        province.NUM === this.latestClickedCity.parent.NUM
    },

    // 点击节点
    clickNode(node, isChildrenAll) {
      // 处理当前节点
      this.setChecked(node, !node.isChecked)

      // 处理父级和子级节点
      if (node.isChecked) {  // 选中
        //处理子节点（取消选中）
        this._cascadeDown(node, currentNode => this.setChecked(currentNode, false))

        //处理父节点
        if (node.parent) {
          if (isChildrenAll) {
            this.$set(node.parent, 'setCount', 1)
          } else {
            this.$set(node, 'setCount', 0)
          }
          if (this.computeChildrenCount(node.parent) !== node.parent.children.length) {
            // 当前层级未全选中 => 递归取消选中父节点
            this._cascadeUp(node, item => this.setChecked(item, false))

          } else {  // 当前层级全选 => 递归选中父节点
            this._cascadeUp(node, (currentNode) => {
              if (this.computeChildrenCount(currentNode) === currentNode.children.length) {
                this.setChecked(currentNode, true)
                currentNode.children.forEach(item => this.setChecked(item, false))
              }
            })
          }
        } else {
          // console.log(node)
        }
      } else {  // 取消选中
        this.setChecked(node, false)
      }
      this.$refs.menuInputFocus.focus();
      // 判断是否选中全国
      this._ifCheckedChina()
    },

    setCount(node, setCount) {
      this.$set(node, 'setCount', setCount)
    },
    // 计算选中的子节点数量
    computeChildrenCount(node, isProvice) {
      let count;
      if (isProvice) {
        count = node.children.filter(item => item.isChecked || item.setCount).length
      }
      count = node.children.filter(item => item.isChecked).length
      this.setCount(node, count)
      // console.log(count,'count',node)
      return count
    },

    // computeChildrenProviceCount(node){
    //   let count;
    //   count = node.children.filter( item => item.setCount!=0).length
    //   // this.setCount(node, count)
    //   console.log(count,'count',node)
    //   return count    
    // },

    //显示标签
    displayTag(node) {
      let directCities = ['1101', '3101', '5001', '1201']
      let centerPart = ''
      if (node.parent && !directCities.some(num => num === node.NUM)) {  // 处理直辖市的特殊情况
        centerPart = node.parent.NAME + '-'
      }
      return centerPart + node.NAME
    },

    querySearch(keyword, cb) {
      if (!this.searchKeyWord || !keyword) {
        cb([]);
        this.visiable = true;
        return;
      }

      let directCities = ['1101', '3101', '5001', '1201']
      this.visiable = false;
      let filterArr = [{}];
      filterArr = this._searchFilter(keyword).map(node => ({
        currentNode: node,
        value: node.NAME,
        code: node.NUM,
        showText: node.NAME.replace(keyword, '<em>' + keyword + '</em>')
      }))
      if (filterArr.length < 1) {
        filterArr.push({ label: '未找到匹配的结果' })
      }
      filterArr.forEach((item, index) => {
        let currentIndex = directCities.indexOf(item.code)
        if (currentIndex != -1) {
          filterArr.splice(index, 1)
        }
      })
      // this.searchQueryString = keyword;
      cb(filterArr);
    },
    searchQueryString(e) {
      let event = window.event || e;
      let val = event.target.value;
      if (!val) {
        this.isSearch = false;
        return
      };
      this.isSearch = true;
      let searchList = []
      this.searchKeyWord = val.trim();
      let directCities = ['1101', '3101', '5001', '1201']
      let filterArr = [];
      filterArr = this._searchFilter(this.searchKeyWord).map(node => ({
        currentNode: node,
        value: node.NAME,
        code: node.NUM,
        showText: node.NAME
      }))
      filterArr.forEach((item, index) => {
        let currentIndex = directCities.indexOf(item.code)
        if (currentIndex != -1) {
          filterArr.splice(index, 1)
        }
      })
      this.searchIndustry = filterArr;
    },
    // 获取查询列表
    _searchFilter(queryString) {
      let result = []
      this._cascadeDown({ children: this.options.normal }, (node) => {
        if (result.length >= 5) return

        let isContainKeyword = node.NAME.indexOf(queryString) !== -1
        isContainKeyword && result.push(node)
      })
      return result;
    },

    doSelect(n) {
      const node = n.currentNode
      let searchKey = this.searchKeyWord;
      //不存在，则添加
      if (!node.isChecked) {
        if (node.parent && node.parent.NUM.length === 4) {
          this.clickCity(node.parent)
        }
        this.clickNode(node)
      }
      // this.searchKeyWord =  this.searchQueryString;//联想会默认回传item的value作为新的searchVal
      // this._scrollTo(`#province${node.NUM.slice(0, 2)}`)
      // this.visiable = false;
    },

    setChecked(node, isChecked) {
      this.$set(node, 'isChecked', isChecked)
      this.initArea()
    },

    closeDialog() {
      this.$emit('on-close')
    },

    // 确认选择，关闭弹窗
    confirm() {
      this.$emit('on-select-region', this.selectedList.map(item => item.NUM));
    },

    // 获取查询列表
    _searchFilter(queryString) {
      let result = []
      this._cascadeDown({ children: this.locationOptions.normal }, (node) => {
        // if(result.length >= 5) return
        let isContainKeyword = node.NAME.indexOf(queryString) !== -1
        isContainKeyword && result.push(node)
      })
      return result;
    },

    // 向下递归节点
    _cascadeDown(node, cb) {
      walk(node.children, cb)

      function walk(list = [], fn) {
        list.forEach(item => {
          fn(item)
          item.children && walk(item.children, fn);
        });
      }
    },

    // 向上递归节点
    _cascadeUp(node, cb) {
      while (node.parent) {
        node = node.parent
        cb(node)
      }
    },

    _ifCheckedChina() {
      const provinceList = this.locationOptions.normal
      const selectedCount = provinceList.filter(node => node.isChecked).length
      if (provinceList.length === selectedCount) {
        this.checkChina()
      }
    },

    _scrollTo(cssSelector) {
      const $dom = document.querySelector(cssSelector)
      if ($dom) {
        this.$refs.cityList.scrollTop = $dom.offsetTop - 150
      }
    },
    clearAll() {
      let selected = [...this.selected.province, ...this.selected.city, ...this.selected.district]
      this._cascadeDown({ children: this.locationOptions.normal }, node => {
        // 选中节点
        iteratorNode(node, selected, () => this.setChecked(node, false))
        // 从normal中搜集热门城市
        // iteratorNode(node, hotNumList, () => hotNodeList.push(node))
      })
      // this.locationOptions.hotNodeList = hotNodeList

      function iteratorNode(node, nodeList = [], cb) {
        let checkedIdx = nodeList.findIndex(num => num === node.NUM)
        if (checkedIdx !== -1) {
          cb()
        }
      }
      this.$emit('changeArea', { province: [], city: [], district: [] })
      this.searchKeyWord = ''
      this.isFocus = true;
      this.initArea()
    },
    removeKeyEnter(e) {
      if (e.target.value == 0) {
        this.searchKeyWord = '';
      }
      if (this.hasValue && !this.searchKeyWord) {
        if (this.deleteCount < 2) { this.deleteCount = this.deleteCount + 1; }
        if (this.deleteCount == 2 && this.selectedList.length != 0) {
          let removeItem = this.selectedList[this.selectedList.length - 1]
          this.setChecked(removeItem, false)
          this.deleteCount = 2;
        }
      }

    },
    showMenu() {
      this.visiable = !this.visiable;
    },
    afterLeave() {
      this.isSearch = false;
      this.searchIndustry = [];
      this.$emit('validateNode');
    }
  }
};
</script>

<style lang='scss' scoped>
// @import '../../../assets/stylesheets/regionmulit';
.search-select-options {
  width: 100%;
  .options-wrapper {
    width: 100%;
    display: flex;
  }
}
.menu-item {
  cursor: pointer;
  position: relative;
}
</style>
<style lang="scss">
// .search-select-wrap{
.select-tag {
  .el-input {
    height: 100%;
    .el-input__inner {
      border: none;
      height: 100%;
      font-size: 12px;
      font-weight: 400;
      color: #595959;
      line-height: 18px;
    }
  }
  .el-input__icon {
    line-height: 24px;
  }
}
// .el-input__icon {
//   line-height: 24px;
// }
// }
.error-border {
  // border-color:#f04134 !important;
  // box-shadow: 0px 0px 4px 0px rgba(240, 65, 52, 0.4);
}

.province-clicked {
  color: #ff9052;
}

// 联想
.el-autocomplete-suggestion.tag-search {
  width: 400px !important;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.35);
  border-radius: 2px;
  li {
    line-height: 24px;
    padding: 0 16px;
    margin: 4px 0;
    .suggestion-text {
      display: none;
    }
    em {
      color: #595959;
    }
    &:nth-of-type(1) {
      &:hover {
        background: none;
      }
      .suggestion-text {
        display: block;
      }
    }
    .no-data {
      text-align: center;
      font-size: 14px;
      font-weight: 400;
      color: #bfbfbf;
      padding: 24px 0;
    }
    i {
      display: none;
    }
    .selected {
      color: #ff9052;
      i {
        display: inline-block;
        float: right;
        line-height: 24px;
      }
      // em{color: #ff9052!important;}
    }
  }
}
.mulity-menu-wrap {
  width: 100%;
  height: 380px;

  .el-input {
    height: 100%;
    .el-input__inner {
      border: none;
      height: 100%;
      font-size: 12px;
      font-weight: 400;
      color: #595959;
      line-height: 20px;
    }
  }
  .el-input__icon {
    line-height: 24px;
  }
  // 滚动区域大小
  .clickselect-scroll_wrap {
    max-height: 350px;
  }
}
.tages-popopver {
  margin-top: 4px !important;
  width: 0;
  min-width: 0;
}
.search-select-options {
  .el-scrollbar__wrap {
    margin-bottom: -17px !important;
    margin-right: -17px !important;
  }
}
</style>